/**
 * A MERCHANT'S POLICY TEXT, DRAWN THE SAME WAY HIS DESCRIPTION IS.
 *
 * dk-store's warranty is 462 characters of Hebrew with `<br><br>` between
 * three separate rules, and his returns promise is a paragraph with a number
 * in it. Rendering either as a flat string glues the rules together, which is
 * the exact defect this whole round exists to fix — one seam away.
 *
 * So it goes through `parseRichText` and `renderNodes`: the same second
 * allow-list, the same React elements built from plain objects, the same
 * absence of `dangerouslySetInnerHTML`. A blurb that carries no markup (an
 * older row, a portal save before the subset existed) falls back to
 * paragraph-per-line, which is what a plain string always meant.
 */
import React, { useMemo } from 'react';
import { parseRichText } from '../../utils/richText';
import { renderNodes, normaliseTables, blocksFromPlain } from './RichDescription';

const PolicyProse = ({ blurb, isRtl, className, testId }) => {
  const blocks = useMemo(() => {
    const parsed = normaliseTables(parseRichText(blurb));
    return parsed.length ? parsed : blocksFromPlain(blurb);
  }, [blurb]);
  if (!blocks.length) return null;
  return (
    <div className={className} dir={isRtl ? 'rtl' : 'ltr'} data-testid={testId}>
      {renderNodes(blocks, testId || 'policy')}
    </div>
  );
};

export default PolicyProse;
